const saveChangesText = () => $('.saveChangesWarning') as JQuery<HTMLElement>;

export default {
	init,
	hideSaveChangesWarning,
    showSaveChangesWarning
};

export function init(): void {
    if(saveChangesText().length) {
        hideSaveChangesWarning();
        $('input, select, textarea').on('change input', (e) => {
            e.stopImmediatePropagation();
            showSaveChangesWarning();
        });

        $('form').on('submit', () => {
            hideSaveChangesWarning();
        });
        
        window.addEventListener('beforeunload', (e) => {
            if(saveChangesText().is(':visible')) {
                e.preventDefault();
                e.returnValue = '';
            }
        });
    }
}

export function hideSaveChangesWarning() {
    saveChangesText().addClass('d-none');
}

export function showSaveChangesWarning() {
    saveChangesText().removeClass('d-none');
}

$(init);